import {Component, OnInit} from '@angular/core';
import {LoadingService} from 'src/app/services/loading.service';
import {CommonService} from 'src/app/services/common.service';
import {MatCheckboxChange} from '@angular/material';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastMessagesService} from '../../../../../services/toast-messages.service';
import {SuperMarketRefrigeratorBudgetService} from '../../../../../services/super-market-refrigerator-budget.service';

@Component({
  selector: 'app-redistribution-first-step',
  templateUrl: './redistribution-first-step.component.html'
})
export class RedistributionFirstStepComponent implements OnInit {
  public refrigeratorKinds: any;
  public refrigeratorCategory: any;
  public formGroup: FormGroup;

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private superMarketBudgetService: SuperMarketRefrigeratorBudgetService,
              private toastMessagesService: ToastMessagesService) {
    this.formGroup = new FormGroup({
      material_id: new FormControl('', Validators.required),
      category_id: new FormControl('', Validators.required),
      is_led: new FormControl(0, Validators.required),
    });
  }

  public async ngOnInit(): Promise<any> {
    try {
      this.loadingService.show();
      this.refrigeratorKinds = await this.commonService.getSimpleList('material');
      this.refrigeratorCategory = await this.commonService.getSimpleList('evaluation/categories');
    } catch (e) {

    } finally {
      this.loadingService.hide();
    }
  }

  public async submit(): Promise<any> {
    let result;
    try {
      this.loadingService.show();

      result = await this.superMarketBudgetService.checkSMRedistribution(this.formGroup.value);

    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δε βρέθηκε εγγραφή για τα στοιχεία της Αίτησης');
    } finally {
      this.loadingService.hide();
    }
    return {
      result
    };
  }

  public changeCheckBoxValue($event: MatCheckboxChange): void {
    $event.checked ? this.formGroup.get('is_led').setValue(1) : this.formGroup.get('is_led').setValue(0);
  }

  public isFormGroupInvalid(): boolean {
    return this.formGroup.invalid;
  }
}
